/* Product-page card interactions: add-to-cart and wishlist toggle.
   Wrapped in IIFE with init guard so loading via multiple sections is safe. */
(function () {
  'use strict';

  if (window.__kscPpCardInitialized) return;
  window.__kscPpCardInitialized = true;

  var WISHLIST_KEY = 'ksc_wishlist';

  /* ── Click delegation on document ────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('.pp-card__atc');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      ppAddToCart(atc);
      return;
    }

    var wish = e.target.closest('.pp-card__wishlist');
    if (wish) {
      e.preventDefault();
      e.stopPropagation();
      ppToggleWishlist(wish, wish.dataset.productId);
      return;
    }
  }, false);

  /* ── Sync wishlisted state across initial + dynamically-added cards ── */
  function ppSyncWishlist(root) {
    (root || document).querySelectorAll('.pp-card__wishlist').forEach(function (btn) {
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';
      if (ppIsInWishlist(btn.dataset.productId)) ppApplyWishlisted(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ppSyncWishlist(); });
  } else {
    ppSyncWishlist();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function () { ppSyncWishlist(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ── Cart ───────────────────────────────────────────────────────────── */
  function ppAddToCart(btn) {
    /* /cart/add.js requires the VARIANT id, not the product id */
    var variantId = btn.dataset.variantId || btn.dataset.productId;
    if (!variantId || btn.dataset.busy === 'true' || btn.disabled) return;
    btn.dataset.busy = 'true';
    btn.setAttribute('aria-busy', 'true');

    /* Line-item properties contributed by the estimated delivery date feature
       (snippets/estimated-delivery.liquid), which cannot use a hidden input
       here because these cards carry no form. Absent whenever that feature is
       off in Theme settings, and the payload is then exactly what it was. */
    var item = { id: variantId, quantity: 1 };
    var edd = window.KSCEstimatedDelivery;
    if (edd && typeof edd.lineProperties === 'function') {
      var lineProps = edd.lineProperties();
      if (lineProps) item.properties = lineProps;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { return Promise.reject(j); }); })
    .then(function () {
      btn.dataset.busy = 'false';
      btn.setAttribute('aria-busy', 'false');
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2500);
      /* Tell the cart drawer (or anything else listening) to refresh + open */
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'pp-card' } }));
    })
    .catch(function (err) {
      btn.dataset.busy = 'false';
      btn.setAttribute('aria-busy', 'false');
      console.error('Cart error:', err);
    });
  }

  /* ── Wishlist (localStorage-backed) ─────────────────────────────────── */
  function ppToggleWishlist(btn, productId) {
    if (!productId) return;
    if (btn.classList.contains('is-wishlisted')) {
      ppRemoveWishlisted(btn);
      ppRemoveFromWishlist(productId);
    } else {
      ppApplyWishlisted(btn);
      ppAddToWishlist(productId);
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { productId: productId } }));
  }

  function ppApplyWishlisted(btn) {
    btn.classList.add('is-wishlisted');
    btn.setAttribute('aria-pressed', 'true');
    var text = btn.querySelector('.pp-card__wishlist-text');
    if (text) text.textContent = 'Added to Loves!';
    var label = btn.getAttribute('aria-label') || '';
    btn.setAttribute('aria-label', label.replace('Add', 'Remove'));
  }

  function ppRemoveWishlisted(btn) {
    btn.classList.remove('is-wishlisted');
    btn.setAttribute('aria-pressed', 'false');
    var text = btn.querySelector('.pp-card__wishlist-text');
    if (text) text.textContent = 'Add to Loves!';
    var label = btn.getAttribute('aria-label') || '';
    btn.setAttribute('aria-label', label.replace('Remove', 'Add'));
  }

  function ppIsInWishlist(id) {
    if (!id) return false;
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]').indexOf(String(id)) !== -1; }
    catch (e) { return false; }
  }
  function ppAddToWishlist(id) {
    try {
      var list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      if (list.indexOf(String(id)) === -1) {
        list.push(String(id));
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      }
    } catch (e) {}
  }
  function ppRemoveFromWishlist(id) {
    try {
      var list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]')
        .filter(function (x) { return x !== String(id); });
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
  }
})();
